import React from "react";
import {
  ArrayInput,
  FormDataConsumer,
  NumberInput,
  ReferenceInput,
  required,
  SelectInput,
  SimpleFormIterator,
} from "react-admin";
import { Grid } from "@mui/material";
import RoomInput from "server/components/Fields/RoomInput";
import CustomTimeOnlyInput from "server/components/Fields/CustomTimeOnlyInput";
import sessionExamsHelper from "components/AcademicYears/Exams/helper";
import { InternshipPlanScheduleTypes } from "utils/constants";
import { graduationRequests } from "api/graduationApi";
import { settings } from "app";

const EditForm = ({ filters }) => {
  const planId = filters?.planId || "";

  return (
    <>
      <Grid
        container
        spacing={2}
      >
        {planId && (
          <Grid
            item
            xs={12}
            md={4}
          >
            <ReferenceInput
              source="disciplineId"
              reference={graduationRequests.getPlanDisciplinesSelect(planId)}
              filter={{ planScheduleType: InternshipPlanScheduleTypes.Individual }}
            >
              <SelectInput
                label="Дисциплина"
                validate={required()}
                optionText="nameBg"
              />
            </ReferenceInput>
          </Grid>
        )}
        <Grid
          item
          xs={12}
          md={4}
        >
          <RoomInput />
        </Grid>

        <Grid
          item
          xs={12}
          md={4}
        >
          <NumberInput
            source="boxNumber"
            label="Бокс номер"
          />
        </Grid>
        <Grid
          item
          xs={12}
        >
          <ArrayInput
            source="timeIntervals"
            label="Времеви интервал"
            defaultValue={[{}]}
          >
            <SimpleFormIterator
              disableReordering
              disableRemove
              disableClear
              inline
              sx={settings.style.iteratorWithoutGap}
            >
              <FormDataConsumer>
                {({ scopedFormData }) => (
                  <>
                    <Grid
                      item
                      xs={12}
                      md={3}
                    >
                      <CustomTimeOnlyInput
                        source="from"
                        label="Начало"
                        required={true}
                        validate={() =>
                          sessionExamsHelper.validateTimeSlots({
                            startTime: scopedFormData?.from,
                            endTime: scopedFormData?.to,
                          })
                        }
                      />
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      md={3}
                    >
                      <CustomTimeOnlyInput
                        source="to"
                        label="Край"
                        required={true}
                        validate={() =>
                          sessionExamsHelper.validateTimeSlots({
                            startTime: scopedFormData?.from,
                            endTime: scopedFormData?.to,
                          })
                        }
                      />
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      md={3}
                    >
                      <ReferenceInput
                        source="dateType"
                        reference={graduationRequests.getScheduleDateTypeSelect()}
                      >
                        <SelectInput
                          optionText="nameBg"
                          label="Тип дата"
                          emptyText={false}
                          fullWidth
                        />
                      </ReferenceInput>
                    </Grid>
                  </>
                )}
              </FormDataConsumer>
            </SimpleFormIterator>
          </ArrayInput>
        </Grid>
      </Grid>
    </>
  );
};

export default EditForm;
